/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Attachment } from '../model';
/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
export const AttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 指定されたドキュメントに紐づく添付ファイルを取得する
         * @summary IDで指定された添付ファイルを取得する
         * @param {string} docId 
         * @param {string} id 
         * @param {string} [downloadAs] 添付ファイルをdownloadしたい場合にダウンロード用ファイル名を指定する。 これを指定するとGCSのresponse headerにcontent-dispositionが追加されダウンロード用リンクになる。 なお、外部リンクのものに指定するとこのパラメータは無視される。 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment: async (docId: string, id: string, downloadAs?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'docId' is not null or undefined
            assertParamExists('getAttachment', 'docId', docId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAttachment', 'id', id)
            const localVarPath = `/documents/{docId}/attachments/{id}`
                .replace(`{${"docId"}}`, encodeURIComponent(String(docId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (downloadAs !== undefined) {
                localVarQueryParameter['downloadAs'] = downloadAs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 指定されたドキュメントに紐づく添付ファイルを取得する
         * @summary IDで指定された添付ファイルを取得する
         * @param {string} docId 
         * @param {string} id 
         * @param {string} [downloadAs] 添付ファイルをdownloadしたい場合にダウンロード用ファイル名を指定する。 これを指定するとGCSのresponse headerにcontent-dispositionが追加されダウンロード用リンクになる。 なお、外部リンクのものに指定するとこのパラメータは無視される。 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachment(docId: string, id: string, downloadAs?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachment(docId, id, downloadAs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentsApiFp(configuration)
    return {
        /**
         * 指定されたドキュメントに紐づく添付ファイルを取得する
         * @summary IDで指定された添付ファイルを取得する
         * @param {string} docId 
         * @param {string} id 
         * @param {string} [downloadAs] 添付ファイルをdownloadしたい場合にダウンロード用ファイル名を指定する。 これを指定するとGCSのresponse headerにcontent-dispositionが追加されダウンロード用リンクになる。 なお、外部リンクのものに指定するとこのパラメータは無視される。 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment(docId: string, id: string, downloadAs?: string, options?: any): AxiosPromise<Attachment> {
            return localVarFp.getAttachment(docId, id, downloadAs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentsApi - interface
 * @export
 * @interface AttachmentsApi
 */
export interface AttachmentsApiInterface {
    /**
     * 指定されたドキュメントに紐づく添付ファイルを取得する
     * @summary IDで指定された添付ファイルを取得する
     * @param {string} docId 
     * @param {string} id 
     * @param {string} [downloadAs] 添付ファイルをdownloadしたい場合にダウンロード用ファイル名を指定する。 これを指定するとGCSのresponse headerにcontent-dispositionが追加されダウンロード用リンクになる。 なお、外部リンクのものに指定するとこのパラメータは無視される。 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApiInterface
     */
    getAttachment(docId: string, id: string, downloadAs?: string, options?: AxiosRequestConfig): AxiosPromise<Attachment>;

}

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI implements AttachmentsApiInterface {
    /**
     * 指定されたドキュメントに紐づく添付ファイルを取得する
     * @summary IDで指定された添付ファイルを取得する
     * @param {string} docId 
     * @param {string} id 
     * @param {string} [downloadAs] 添付ファイルをdownloadしたい場合にダウンロード用ファイル名を指定する。 これを指定するとGCSのresponse headerにcontent-dispositionが追加されダウンロード用リンクになる。 なお、外部リンクのものに指定するとこのパラメータは無視される。 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getAttachment(docId: string, id: string, downloadAs?: string, options?: AxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).getAttachment(docId, id, downloadAs, options).then((request) => request(this.axios, this.basePath));
    }
}
